import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';

import { MenuItemButton as Component } from './menu-list-button';
import type { IDeps, TMenuListButton } from './models';

export const MenuListButton = createWidget<IDeps, TMenuListButton>({
    Button,
})(Component);
